import { useMutation } from "@tanstack/react-query";
import { lodInfApi } from "components/api/comm";
import { useAuthContext } from "components/context/authContext";
import HomeView from "components/view/home";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { alertControl } from "util/commAction";

export default function HomePage() {
  const { t } = useTranslation();

  const { setLodInf } = useAuthContext();
  const { lodNo } = useParams();
  const navigate = useNavigate();
  // 숙소상세 정보
  const lodInfMutation = useMutation({
    mutationFn: lodInfApi,
    onSuccess: (res) => {
      if (res) {
        if (res.data) {
          const { lodInfo, defAdltPerCt, defRmCt } = res.data;

          setLodInf({
            ...lodInfo,
            defAdltPerCt,
            defRmCt,
          });
          localStorage.setItem(
            "lodInf",
            JSON.stringify({
              ...lodInfo,
              defAdltPerCt,
              defRmCt,
            })
          );
        }
      }
    },
  });

  useEffect(() => {
    if (lodNo === "undefined" || lodNo === "null") {
      alertControl({
        isOpen: true,
        inner: t("alr_lod_no_select"),
        click: () => {
          navigate("/");
        },
      });
    }
  }, []);

  useEffect(() => {
    if (lodNo && lodNo !== "undefined" && lodNo !== "null") {
      lodInfMutation.mutate({ lodNo });
    }
  }, [lodNo]);

  return (
    <>
      <HomeView />
    </>
  );
}
